import { ReactNode } from 'react';
import clsx from 'clsx';

const gaps = { 0: '', 0.5: 'gap-0.5', 1: 'gap-1', 2: 'gap-2', 3: 'gap-3', 4: 'gap-4', 5: 'gap-5', 6: 'gap-6' } as const;

export function Row({ gap = 2, align = 'center', justify = 'start', wrap, className, children }: {
  gap?: keyof typeof gaps;
  align?: 'start' | 'center' | 'end' | 'baseline';
  justify?: 'start' | 'center' | 'end' | 'between';
  wrap?: boolean;
  className?: string;
  children: ReactNode;
}) {
  const a = { start: 'items-start', center: 'items-center', end: 'items-end', baseline: 'items-baseline' }[align];
  const j = { start: 'justify-start', center: 'justify-center', end: 'justify-end', between: 'justify-between' }[justify];
  return <div className={clsx('flex', gaps[gap], a, j, wrap && 'flex-wrap', className)}>{children}</div>;
}
